module.exports = __webpack_public_path__ + "assets/img/diagram01.a267a188.svg";